export type BaseTrackPayload = {
    stageType?: number;
    recordId?: number;
    funcId: string;
    panelPosition?: string;
};

export const baseTrack = (payload: BaseTrackPayload, timings: Array<'click' | 'use'>) => {
    const { stageType, recordId, funcId, panelPosition } = payload;

    const params: Record<string, any> = {
        func_id: funcId,
        layer_num: '1',
        record_id: recordId ? String(recordId) : '',
        ...(panelPosition ? { panel_position: panelPosition } : {}),
    };

    if (typeof stageType !== 'undefined') {
        params['canvas_type'] = stageType;
    }

    const CLICK_EVENT = 'hb_layers_func_click';
    const USE_EVENT = 'hb_layers_func_use';

    if (timings.includes('click')) window._stat_track(CLICK_EVENT, params);
    if (timings.includes('use')) window._stat_track(USE_EVENT, params);
};
